export const toastStyles = { marginBottom: "5rem" };
